// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"26d5c22f","113":"8ba48cde","142":"4fa66571","358":"2e389533","438":"5528ed82","651":"45937ca6","895":"a4b1c5ee"}[chunkId] + ".chunk.js";
};